import {getEnv} from '@config/getEnv';
import {FetchException} from '@core/exceptions';
import {getLocale} from '@utils/getLocale';
import {IFetchParams, IFetchResponse} from './http.model';
import {
    addMethodsToFetch,
    checkThrowCancelException,
    checkThrowMaintenanceException,
    finalizeUrl,
    makeRequest,
} from './http.util';
import {makeMockedRequest} from './httpMock.util';

export const requestFetch = async <T>(
    url: string,
    params: IFetchParams,
): Promise<IFetchResponse<T>> => {
    const locale = await getLocale();
    url = finalizeUrl(url, locale);
    try {
        const res = await (getEnv('NEXT_PUBLIC_E2E')
            ? makeMockedRequest<T>(url, params)
            : makeRequest<T>(url, params));
        return res;
    } catch (error) {
        checkThrowCancelException(error as FetchException);
        checkThrowMaintenanceException(error as FetchException);
        throw error;
    }
};

export const http = addMethodsToFetch(requestFetch);
